"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _omit = _interopRequireDefault(require("lodash/omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Icon = function Icon(props) {
  var CLASS_NAME = 'ifit-react-icon';
  var styles = {
    svg: {
      display: 'inline-block',
      verticalAlign: 'middle',
      transformOrigin: '50% 50%'
    },
    path: {
      fill: props.color
    }
  };

  var invertStyles = _objectSpread({}, styles.svg, {
    transform: 'rotate(180deg)'
  });

  var iconStyle = props.icon.invert ? invertStyles : styles.svg;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    style: iconStyle,
    className: (0, _classnames["default"])(CLASS_NAME, props.className),
    width: "".concat(props.size).concat(props.unitSize),
    height: "".concat(props.size).concat(props.unitSize),
    viewBox: props.icon.viewBox
  }, (0, _omit["default"])(props, Object.keys(Icon.propTypes)), {
    "data-icon-name": props.icon.name,
    onClick: props.onClick
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: styles.path,
    d: props.icon.path,
    fillRule: "evenodd"
  }));
};

Icon.propTypes = {
  className: _propTypes["default"].string,
  icon: _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    path: _propTypes["default"].string.isRequired,
    viewBox: _propTypes["default"].string.isRequired,
    invert: _propTypes["default"].bool
  }).isRequired,
  size: _propTypes["default"].number,
  unitSize: _propTypes["default"].string,
  color: _propTypes["default"].string,
  onClick: _propTypes["default"].func
};
Icon.defaultProps = {
  size: 18,
  unitSize: 'px',
  color: 'black'
};
var _default = Icon;
exports["default"] = _default;